"use client";

import { InboxHome } from "@/app/(inbox)/components/InboxHome";

// This prevents a bug in production where the page triggers a hard reload on initial route change
export const dynamic = "force-dynamic";

export default function RootPage() {
  return <InboxHome />;
}
